module.exports = __webpack_public_path__ + "img/desire_005.b3ddb6c.png";